import { connect } from 'react-redux';
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { lookaheadActions } from '../../actions/lookahead.actions';

import { 
    getTrades,
    getSelectedPhasePlan,
    getConstraintsList,
    isConstraintLogDialogOpen,
    getPhaseTags
} from '../../selectors/phaseplan.selector'

import {
    getTags, getLookaheadTags
} from '../../selectors/lookahead.selector'

import { getProjectId, getProjectUsers } from '../../selectors/project.selector';
import { ThunkDispatch } from 'redux-thunk';
import { dialogActions } from '../../actions/dialog.actions';
import { withFirebase } from 'react-redux-firebase';
import { withRouter } from 'react-router';
import ConstraintLogDialog from './ConstraintLogDialog';
import { getLocationPathName } from '../../selectors/util.selector';


const mapStateToProps = (state: any) => ({
    constraintList: getConstraintsList(state),
    projectUsers: getProjectUsers(state),
    isConstraintLogDialogOpen: isConstraintLogDialogOpen(state),
    phaseTags: getPhaseTags(state),
    lookaheadTags: getLookaheadTags(state),
    pathName: getLocationPathName(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

  return {
    closeDialogValue: () => dispatch(dialogActions.closeConstraintLogDialog()),
    openConstraintDialog: (constaintId?: string) => dispatch(dialogActions.openConstraintDialog(constaintId))
  }
};

export default compose(
  withRouter,
  withFirebase,
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),
)(ConstraintLogDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/ConstraintLogDialogContainer.ts